import React, { useRef } from "react";
import { Box, Container } from "@mui/material";
import DashboardNav from "components/dashboard/layout/DashboardNav";
// import BetaDisclaimer from "components/dashboard/BetaDisclaimer";
import { useFacility } from "hooks/useFacility";
import { useAuth } from "hooks/useAuth";

const pageColumnSx = {
  maxWidth: "1024px",
  pt: 1.875,
  px: 1.875,
  pb: 6.25,
};

const DashboardLayout = ({ children, fullWidth = false }) => {
  const boxRef = useRef(null);
  const { data } = useFacility();
  const { userData, isVerified } = useAuth();

  // Redirect if vaccines-only facility
  const only_vaccines = data?.type === 3;
  if (
    only_vaccines &&
    window.location.pathname.replaceAll("/", "") === "dashboard"
  ) {
    window.location = "/dashboard/vaccine/queue";
    return null;
  }

  return (
    <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
      <DashboardNav boxRef={boxRef}>
      {fullWidth ? (
        <>{children}</>
      ) : (
        <Container maxWidth={false} sx={pageColumnSx}>
          {children}
        </Container>
      )}
      {/* <BetaDisclaimer /> */}
      </DashboardNav>
    </Box>
  );
};

export default DashboardLayout;
